import { useState } from "react";
import { useNavigate } from "react-router-dom";
import useAuthStore from "../../stores/useAuthStore";
import {
  Container,
  Row,
  Col,
  CardGroup,
  Card,
  CardBody,
  Button,
  InputGroup,
} from "reactstrap";
import { PacmanLoader } from "react-spinners";
import { FormattedMessage, useIntl } from "react-intl";

function Signin() {
  const intl = useIntl();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const isLoggingIn = useAuthStore((state) => state.isLoggingIn);
  const error = useAuthStore((state) => state.error);
  const signIn = useAuthStore((state) => state.signIn);

  const handleSubmit = (e) => {
    e.preventDefault();
    signIn(email, password);
  };

  const resetPassword = () => {
    navigate("/password/reset");
  };

  const openManual = () => {
    window.open("http://ftp.pol.se/public/LearnWARE/manual_LWC.pdf", "_blank");
  };

  if (isLoggingIn) {
    return (
      <div
        className="sweet-loading"
        style={{ position: "fixed", top: "50%", left: "50%" }}
      >
        <PacmanLoader color={"#20a8d8"} loading={true} />
      </div>
    );
  }

  return (
    <div className="form">
          <div className="app flex-row align-items-center">
            <Container>
              <Row className="justify-content-center">
                <Col md="8">
                  <CardGroup>
                    <Card
                      className="text-white bg-primary py-5 d-md-down-none"
                      style={{ width: 44 + "%" }}
                    >
                      <CardBody className="text-center">
                        <div>
                          <img
                            style={{ width: 100 + "%" }}
                            src={"img/LearnWareLoggo.png"}
                            className="img-avatar"
                            alt="LearnWARE logga in"
                          />
                        </div>
                      </CardBody>
                    </Card>
                    <img
                      src={"img/m_logo.png"}
                      style={{
                        maxWidth: "92%",
                        position: "absolute",
                        top: "-190px",
                        marginLeft: "5px",
                      }}
                      alt="Signin logo"
                      className="d-lg-none img-responsive"
                    />
                    <Card className="p-4">
                      <CardBody>
                        <h1>
                          <FormattedMessage id="signin.header" />
                        </h1>
                        <p className="text-muted">
                          <FormattedMessage id="signin.ingress" />
                        </p>
                        <form onSubmit={handleSubmit}>
                          <InputGroup className="mb-3">
                            <input
                              autoFocus
                              name="email"
                              autoComplete="username"
                              style={{ padding: "5px" }}
                              type="email"
                              required
                              value={email}
                              onChange={(e) => setEmail(e.target.value)}
                              placeholder={intl.formatMessage({
                                id: "signin.placeholder.username",
                              })}
                            />
                          </InputGroup>
                          <InputGroup className="mb-4">
                            <input
                              name="password"
                              autoComplete="current-password"
                              style={{ padding: "5px" }}
                              type="password"
                              required
                              value={password}
                              onChange={(e) => setPassword(e.target.value)}
                              placeholder={intl.formatMessage({
                                id: "signin.placeholder.password",
                              })}
                            />
                          </InputGroup>
                          <Row>
                            <Col xs="6">
                              <Button
                                type="submit"
                                color="primary"
                                className="px-4"
                              >
                                <FormattedMessage id="signin.button.login" />
                              </Button>
                            </Col>
                            <Col xs="6" className="text-right">
                              <Button
                                type="button"
                                color="link"
                                className="px-0"
                                onClick={resetPassword}
                              >
                                <FormattedMessage id="signin.button.forgotpassword" />
                              </Button>
                            </Col>
                          </Row>
                          <Row>
                            <Col>
                              {error && (
                                <div className="info-red">
                                  <FormattedMessage
                                    id={error}
                                  />
                                </div>
                              )}
                            </Col>
                          </Row>
                          <Row>
                            <Col xs="6">
                              <Button
                                type="button"
                                color="link"
                                className="px-0"
                                onClick={openManual}
                              >
                                <FormattedMessage id="Manual" />
                              </Button>
                            </Col>
                          </Row>
                        </form>
                      </CardBody>
                    </Card>
                  </CardGroup>
                </Col>
              </Row>
            </Container>
          </div>
    </div>
  );
}

export default Signin;
